import i18n from "../../i18next";
import {TransactionEntryStateType} from "../../api/services/Payments/payments.interface";

export default function getTransactionEntryStateStatusName(state: TransactionEntryStateType) {
  return i18n.t(`dashboard.payments.statuses.transactionEntryState.${state}`);
}
